// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-modal {
  width: min(92vw, 640px);
  max-height: 82vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.legal-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.legal-modal__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.legal-modal__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.legal-modal__close .icon { width: 1.1rem; height: 1.1rem; }

.legal-modal__close:hover {
  background: #23384f;
  color: #fff;
}

.legal-modal__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  font-size: 0.9rem;
  line-height: 1.6;
  /* Match the app's shared dark-theme scrollbar (see styles.css). */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.legal-modal__body::-webkit-scrollbar {
  width: 8px;
}

.legal-modal__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.legal-modal__body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

.legal-modal__body h4 {
  color: #fff;
  font-size: 0.95rem;
  margin: 1.1rem 0 0.4rem;
}

.legal-modal__body p {
  margin: 0 0 0.7rem;
}

.legal-modal__body .legal-modal__full-link {
  margin-top: 1.1rem;
  padding-top: 0.9rem;
  border-top: 1px solid rgba(74, 158, 255, 0.2);
}

.legal-modal__body .legal-modal__full-link a {
  color: #4a9eff;
  font-weight: 600;
  text-decoration: none;
}

.legal-modal__body .legal-modal__full-link a:hover {
  text-decoration: underline;
}

.legal-modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.9rem 1.3rem;
  border-top: 1px solid rgba(74, 158, 255, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/legal-modal/legal-modal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,4BAA4B,aAAa,EAAE,cAAc,EAAE;;AAE3D;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kEAAkE;EAClE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C","sourcesContent":[".legal-modal {\r\n  width: min(92vw, 640px);\r\n  max-height: 82vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.legal-modal__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.legal-modal__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.legal-modal__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.legal-modal__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.legal-modal__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.legal-modal__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  font-size: 0.9rem;\r\n  line-height: 1.6;\r\n  /* Match the app's shared dark-theme scrollbar (see styles.css). */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.legal-modal__body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.legal-modal__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.legal-modal__body::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n.legal-modal__body h4 {\r\n  color: #fff;\r\n  font-size: 0.95rem;\r\n  margin: 1.1rem 0 0.4rem;\r\n}\r\n\r\n.legal-modal__body p {\r\n  margin: 0 0 0.7rem;\r\n}\r\n\r\n.legal-modal__body .legal-modal__full-link {\r\n  margin-top: 1.1rem;\r\n  padding-top: 0.9rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.legal-modal__body .legal-modal__full-link a {\r\n  color: #4a9eff;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.legal-modal__body .legal-modal__full-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.legal-modal__footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 0.9rem 1.3rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
